import React, { useState, useEffect } from 'react'

import { Container, CssBaseline, CircularProgress, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
	container: {
		width: '208px',
		border: '1px solid #D0CFD2',
		height: '208px',
		borderRadius: '50%',
		color: 'inherit',
		border: 0,
		cursor: 'pointer',
		margin: 0,
		display: 'inline-flex',
		outline: 0,
		padding: 0,
		alignItems: 'center',
		userSelect: 'none',
		'-moz-appearance': 'none',
		justifyContent: 'center',
		opacity: 0.6,
		zIndex: 1,
		position: 'absolute',
		backgroundColor: '#FFFFFF'
	},
	paper: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center'
	}
}))

const Loading = (props) => {
	const classes = useStyles()
	const [progress, setProgress] = useState(0)

	useEffect(() => {
		const tick = () => {
			// reset when reaching 100%
			setProgress((oldProgress) => (oldProgress >= 100 ? 0 : oldProgress + 1))
		}

		const timer = setInterval(tick, 20)
		return () => {
			clearInterval(timer)
		}
	}, [])

	return (
		<Container className={classes.container} maxWidth={false} component="span">
			<CssBaseline />
			<div className={classes.paper}>
				<CircularProgress variant="determinate" size="5rem" value={progress} />
			</div>
		</Container>
	)
}

export default Loading
